import React from 'react';
import { MessageCircle } from 'lucide-react';

export const CTA = () => {
  const whatsappNumber = '5521965983038';
  const whatsappMessage = 'Olá, vim pelo Google e quero mais informações para fazer parte do time de Traders.';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="cta" className="cta-section">
      <div className="cta-container">
        <div className="cta-content">
          <div className="cta-text-center">
            <h2 className="cta-title">
              Pronto Para Começar Sua Jornada no Trading?
            </h2>
            <p className="cta-subtitle">
              Junte-se a milhares de traders que já estão operando com segurança e profissionalismo na Sofia Investe. Entre em contato agora e receba acesso exclusivo.
            </p>
            
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp"
            >
              <MessageCircle size={24} />
              Comece agora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
